export const normalizeServiceStatus = (status: string): string => {
  if (status.startsWith('service.status.')) {
    return status.replace('service.status.', '').toUpperCase();
  }
  if (status.startsWith('tbl.status.')) {
    return status.replace('tbl.status.', '').toUpperCase();
  }
  if (status.startsWith('task.status.')) {
    return status.replace('task.status.', '').toUpperCase();
  }
  if (status.startsWith('bundle.state.')) {
    return status.replace('bundle.state.', '').toUpperCase();
  }
  return status;
};
